import { createReducer } from "redux-act";

import { placementAnswerKeyOfRow } from "@/modules/curriculum";
import * as a from "../actions/quizesAnswers";

const getDefaultState = () => ({
  isLoadingQuizesAnswers: false,
  quizesAnswers: {},
});

export default () =>
  createReducer(
    {
      [a.getQuizesAnswers]: (state) => {
        return {
          ...state,
          isLoadingQuizesAnswers: true,
        };
      },
      [a.receivedQuizesAnswers]: (state, payload) => {
        return {
          ...state,
          quizesAnswers: payload,
          isLoadingQuizesAnswers: false,
      }},
      [a.quizesAnswersError]: (state) => ({
          ...state,
          isLoadingQuizesAnswers: false,
          quizesAnswers: {},
      }),
      [a.updateCurrentStateofQuizesAnswers]: (state, payload) => {
        if (!payload?.question) {
          return {
            ...state,
            isLoadingQuizesAnswers: false,
          };
        }
        return {
          ...state,
          quizesAnswers: {
            ...state.quizesAnswers,
            [placementAnswerKeyOfRow(payload)]: [payload],
          },
          isLoadingQuizesAnswers: false,
        }
      },
    },
    getDefaultState()
  );
